import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { YSButton } from "../../../uikit/YSButton";
import { useState } from "react";
import { Form, Formik } from "formik";
import ErrorIcon from "@mui/icons-material/Error";
import {
  greyColor,
  warnColor,
  InputSMBoxStyle,
  BtnSMGroupStyle,
  DRxTextareaStyle,
  DRxInputStyle,
  lightGreyColor,
  ContentStyle,
  DRxSelectStyle,
  DRxCheckboxStyle,
  blackColor,
  AlertInfo,
} from "../../../Theme";
import { DialogPopup } from "../../../components/DialogPopup";
import TimeIcon from "../../../images/icons/TimeIcon.svg";
import YSCheckBox from "../../../uikit/YSCheckBox";
import DRxTextarea from "../../../uikit/DRxTextarea";
import DRxInput from "../../../uikit/DRxInput";
import TabsNav from "../../../components/TabsNav";
import TimeList from "../../../components/TimeList";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import { MedicationHistoryDrugUpdate } from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";

const initialStateDrugUpdate = {
  Drug: "",
  SIG: "",
  Quantity: "",
  Refill: "",
  Substitutions: "",
  Delivery: "",
  Dose: "",
  Units: "",
  Freq: "",
  ModifiedSIG: "",
  ModifiedSIGFreeText: "",
  freeText: false,
  TimeData: "",
  Comments: "",
  Morning: false,
  Noon: false,
  Evening: false,
  Night: false,
  Bedtime: false,
  BeforeMeals: false,
  AfterMeals: false,
  BeforeBed: false,
};

export default function DrugUpdate(props: any) {
  const AllDropdwonsState = useSelector((ReduxState: any) => {
    return { ...ReduxState.GlobalDropdownSlice.DropdownLists };
  }); //redux data
  const { state }: any = useLocation();
  const [free, SetFree] = useState(true);
  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const [showPopup, setShowPopup] = useState(false);
  const handleShowPopupClick = () => {
    setShowPopup(true);
  };
  const handleHidePopupClick = () => {
    setShowPopup(false);
  };

  const OnSubmitDrugUpdate = async (values: any) => {
    try {
      const params = new URLSearchParams();
      params.append("medicationHistoryDrugIds", state?.selectedDrugIds);
      params.append("oldsig", state?.selectionData[0]?.sig);
      params.append(
        "updatedsig",
        free
          ? `${values.Delivery} ${values.Dose} ${values.Units} ${values.Freq} ${values.TimeData}`
          : values.ModifiedSIGFreeText
      );
      params.append("updatedcomment", values.Comments);

      const result = await MedicationHistoryDrugUpdate(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
      } else {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  return (
    <>
      <TabsNav />{" "}
      <ContentStyle>
        <Typography component="h6" color="primary" variant="h6">
          Drug Update
        </Typography>
        <Formik
          enableReinitialize={true}
          initialValues={initialStateDrugUpdate}
          onSubmit={(values) => {
            OnSubmitDrugUpdate(values);
          }}
        >
          {(registerProps) => (
            <Form onSubmit={registerProps.handleSubmit}>
              <Grid
                container
                item
                xs={12}
                spacing={0}
                alignItems="top"
                justifyContent="space-between"
                columnSpacing={4}
              >
                <Grid item xs={12} md={12} lg={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="rxrequireddrug"
                    >
                      Drug
                    </Typography>{" "}
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="Drug"
                          name="Drug"
                          type="text"
                          className=""
                          disabled={true}
                          value={state?.selectionData[0]?.description}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="sig"
                    >
                      SIG
                    </Typography>
                    <Box>
                      <DRxInputStyle>
                        <DRxInput
                          id="SIG"
                          name="SIG"
                          type="text"
                          className=""
                          disabled={true}
                          value={state?.selectionData[0]?.sig}
                          onChange={registerProps.handleChange}
                          onBlur={registerProps.handleBlur}
                          error={
                            registerProps.touched.SIG &&
                            Boolean(registerProps.errors.SIG)
                          }
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="quantity"
                    >
                      Quantity
                    </Typography>
                    <Box className="nested">
                      <DRxInputStyle>
                        <DRxInput
                          id="quantity"
                          name="Quantity"
                          type="text"
                          className=""
                          disabled={true}
                          value={state?.selectionData[0]?.quantity}
                        />
                      </DRxInputStyle>
                      <Box className="nested">
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="refill"
                          className="mr suffix"
                          marginRight={2}
                        >
                          Refill
                        </Typography>
                        <Box className="nested">
                          <DRxInputStyle>
                            <DRxInput
                              id="refill"
                              name="Refill"
                              type="text"
                              className=""
                              disabled={true}
                              value={state?.selectionData[0]?.refills}
                              onChange={registerProps.handleChange}
                              onBlur={registerProps.handleBlur}
                              error={
                                registerProps.touched.Refill &&
                                Boolean(registerProps.errors.Refill)
                              }
                            />
                          </DRxInputStyle>
                        </Box>
                      </Box>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      color={greyColor}
                      variant="body2"
                      htmlFor="sig"
                    >
                      Substitutions
                    </Typography>
                    <Box>
                      <DRxInputStyle>
                        <DRxSelect2
                          name="Substitutions"
                          id="substitutionCode"
                          disabled={true}
                          options={
                            AllDropdwonsState?.substitutionCodeOptions ?? [
                              { label: "", value: "" },
                            ]
                          }
                          onChange={(option: any, e: any) => {
                            registerProps.setFieldValue(
                              "Substitutions",
                              e.props.children
                            );
                          }}
                          value={state?.selectionData[0]?.substitutionCode}
                        />
                      </DRxInputStyle>
                    </Box>
                  </InputSMBoxStyle>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    style={{
                      borderTop: `1px solid ${lightGreyColor}`,
                      marginBottom: 20,
                    }}
                  ></Box>
                </Grid>
                {free ? (
                  <>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={blackColor}
                          variant="body2"
                          fontWeight={400}
                          style={{
                            marginTop: 7,
                            whiteSpace: "nowrap",
                          }}
                          className="mdmw"
                        >
                          Route of <br />
                          Administration
                        </Typography>
                        <DRxSelectStyle>
                          <DRxSelect2
                            id="delivery"
                            disabled={!free}
                            name="Delivery"
                            options={
                              AllDropdwonsState?.sigDeliveryOptions?.map(
                                (each: any) => ({
                                  label: each?.name,
                                  value: each?.name,
                                })
                              ) ?? [{ label: "", value: "" }]
                            }
                            onChange={(option: any, e: any) => {
                              registerProps.setFieldValue(
                                "Delivery",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.Delivery}
                            onBlur={registerProps.handleBlur}
                            errorMessage={
                              registerProps.errors.Delivery &&
                              registerProps.touched.Delivery
                            }
                          />
                        </DRxSelectStyle>
                      </InputSMBoxStyle>
                    </Grid>{" "}
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        {" "}
                        <Typography
                          component="label"
                          variant="body2"
                          color={blackColor}
                          fontWeight={400}
                          style={{
                            marginTop: 7,
                            whiteSpace: "nowrap",
                          }}
                          className="xsmw"
                        >
                          Dose
                        </Typography>
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="Dose"
                            id="dose"
                            disabled={!free}
                            options={
                              AllDropdwonsState?.sigDoseOptions?.map(
                                (each: any) => ({
                                  label: each?.name,
                                  value: each?.name,
                                })
                              ) ?? [{ label: "", value: "" }]
                            }
                            onChange={(option: any, e: any) => {
                              registerProps.setFieldValue(
                                "Dose",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.Dose}
                            errorMessage={
                              registerProps.touched.Dose &&
                              registerProps.errors.Dose
                            }
                          />
                        </DRxSelectStyle>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          variant="body2"
                          fontWeight={400}
                          color={blackColor}
                          style={{
                            marginTop: 7,
                            whiteSpace: "nowrap",
                          }}
                          className="mdmw"
                        >
                          Units
                        </Typography>
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="Units"
                            disabled={!free}
                            id="units"
                            options={
                              AllDropdwonsState?.sigDoseUnitsOptions?.map(
                                (each: any) => ({
                                  label: each?.name,
                                  value: each?.name,
                                })
                              ) ?? [{ label: "", value: "" }]
                            }
                            onChange={(options: any, e: any) => {
                              registerProps.setFieldValue(
                                "Units",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.Units}
                            errorMessage={
                              registerProps.touched.Units &&
                              registerProps.errors.Units
                            }
                          />
                        </DRxSelectStyle>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          variant="body2"
                          color={blackColor}
                          fontWeight={400}
                          style={{
                            marginTop: 7,
                            whiteSpace: "nowrap",
                          }}
                          className="xsmw"
                        >
                          Freq
                        </Typography>
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="Freq"
                            disabled={!free}
                            id="freq"
                            options={
                              AllDropdwonsState?.sigFreqOptions?.map(
                                (each: any) => ({
                                  label: each?.name,
                                  value: each?.name,
                                })
                              ) ?? [{ label: "", value: "" }]
                            }
                            onChange={(option: any, e: any) => {
                              registerProps.setFieldValue(
                                "Freq",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.Freq}
                            errorMessage={
                              registerProps.touched.Freq &&
                              registerProps.errors.Freq
                            }
                          />
                        </DRxSelectStyle>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <InputSMBoxStyle>
                        {" "}
                        <Typography
                          component="label"
                          color={blackColor}
                          variant="body2"
                          fontWeight={400}
                          style={{
                            marginTop: 7,
                            whiteSpace: "nowrap",
                          }}
                          className="mdmw"
                        >
                          Modified SIG
                          <Typography
                            component="span"
                            color={warnColor}
                            variant="body2"
                          >
                            *
                          </Typography>
                        </Typography>
                        <DRxInputStyle className="icon">
                          <DRxInput
                            id="sig"
                            name="ModifiedSIG"
                            type="text"
                            className="input"
                            disabled={false}
                            value={
                              free
                                ? `${registerProps.values.Delivery} ${registerProps.values.Dose} ${registerProps.values.Units} ${registerProps.values.Freq}` +
                                  registerProps.values.TimeData
                                : ""
                            }
                          />{" "}
                          <Formik
                            initialValues={initialStateDrugUpdate}
                            onSubmit={(values) => {
                              let sigWithTime = "";
                              if (values.Morning)
                                sigWithTime = sigWithTime + " at Morning ";
                              if (values.Night)
                                sigWithTime = sigWithTime + " at Night";
                              if (values.AfterMeals)
                                sigWithTime = sigWithTime + " at AfterMeals";
                              if (values.Bedtime)
                                sigWithTime = sigWithTime + " at Bedtime";
                              if (values.Noon)
                                sigWithTime = sigWithTime + " at Noon";
                              if (values.BeforeBed)
                                sigWithTime = sigWithTime + " at BeforeBed";
                              if (values.BeforeMeals)
                                sigWithTime = sigWithTime + " at BeforeMeals";
                              if (values.Evening)
                                sigWithTime = sigWithTime + " at Evening";
                              registerProps.setFieldValue(
                                "TimeData",
                                sigWithTime
                              );
                            }}
                          >
                            {({ handleSubmit }) => (
                              <DialogPopup
                                windowsize={"sm"}
                                icon={TimeIcon}
                                title={"Time"}
                                show={showPopup}
                                handleShowPopupClick={handleShowPopupClick}
                                handleHidePopupClick={handleHidePopupClick}
                              >
                                <Form onSubmit={handleSubmit}>
                                  {free && (
                                    <TimeList
                                      showPopup
                                      setShowPopup
                                      handleShowPopupClick={
                                        handleShowPopupClick
                                      }
                                      handleHidePopupClick={
                                        handleHidePopupClick
                                      }
                                      Timedata={initialStateDrugUpdate}
                                    />
                                  )}
                                </Form>
                              </DialogPopup>
                            )}
                          </Formik>
                        </DRxInputStyle>
                      </InputSMBoxStyle>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} md={12}>
                    <InputSMBoxStyle>
                      {" "}
                      <Typography
                        component="label"
                        color={blackColor}
                        variant="body2"
                        fontWeight={400}
                        style={{
                          marginTop: 7,
                          whiteSpace: "nowrap",
                        }}
                        className="mdmw"
                        htmlFor="freeSig"
                      >
                        Modified SIG
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body2"
                        >
                          *
                        </Typography>
                      </Typography>
                      <DRxTextareaStyle className="sig">
                        <DRxTextarea
                          type="textarea"
                          name="ModifiedSIGFreeText"
                          id={"freeSig"}
                        />
                      </DRxTextareaStyle>
                    </InputSMBoxStyle>
                  </Grid>
                )}
                <Grid item xs={12} md={12}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      className="mdmw"
                    ></Typography>
                    <DRxCheckboxStyle>
                      <YSCheckBox
                        label="Use free text"
                        name="FreeText"
                        onChange={() => {
                          registerProps.setFieldValue("freeText", !free);
                          SetFree(!free);
                        }}
                      />
                    </DRxCheckboxStyle>
                  </InputSMBoxStyle>
                </Grid>{" "}
                <Grid item xs={12}>
                  <InputSMBoxStyle>
                    <Typography
                      component="label"
                      variant="body2"
                      fontWeight={600}
                      color={greyColor}
                      style={{
                        marginTop: 8,
                        whiteSpace: "nowrap",
                      }}
                      className="mdmw"
                    >
                      Comments
                      <Typography
                        component="span"
                        color={warnColor}
                        variant="body2"
                      >
                        *
                      </Typography>
                    </Typography>
                    <DRxTextareaStyle>
                      <DRxTextarea
                        type="textarea"
                        name="Comments"
                        id={"comments"}
                        placeholder={"Enter comments"}
                      />
                    </DRxTextareaStyle>
                  </InputSMBoxStyle>
                </Grid>{" "}
                <Grid item xs={12}>
                  <BtnSMGroupStyle style={{ marginTop: 30 }}>
                    <YSButton
                      size="large"
                      className=""
                      color="primary"
                      dataTestId="submitBtn"
                      variant="outlined"
                      disabled={false}
                      type="reset"
                      children={"Reset"}
                      onClick={null}
                    />
                    <YSButton
                      size="large"
                      className=""
                      color="primary"
                      dataTestId="submitBtn"
                      variant="contained"
                      disabled={false}
                      type="submit"
                      children={"Submit"}
                      onClick={null}
                    />{" "}
                  </BtnSMGroupStyle>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        <Grid item xs={12}>
          <AlertInfo marginBottom={1} marginTop={1}>
            <ErrorIcon style={{ color: "black" }} />
            <Typography color={"error"}>
              Updating medications on this screen only updates the medication in
              Digital Rx. No communication is sent to the pharmacy during this
              process.
            </Typography>
          </AlertInfo>
        </Grid>
      </ContentStyle>
      <YSSnackBar
        message={StateData.message}
        variant={StateData.variant}
        open={StateData.open}
        handleClose={() => {
          SetStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
